import './UserProfilePage.styles.scss';

import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DocTitleScrollTop from '../../utils/DocTitleScrollTop';

import { Avatar, Paper, Tab, Tabs, Typography } from '@material-ui/core';
import ProfilePosts from './user-profile-components/ProfilePosts';
import ProfileFollowers from './user-profile-components/ProfileFollowers';
import ProfileFollowing from './user-profile-components/ProfileFollowing';
import Axios from 'axios';
import customHistory from '../../history';
import UesrContext from '../../contexts/user-context/UserProvider';
import ContentLoader from 'react-content-loader';
import pickSkeletonColor from '../../utils/pickSkeletonColor';
import MyThemeContext from '../../contexts/theme-context/ThemeProviderContext';
import ButtonWithLoading from '../../common/button-with-loading/ButtonWithLoading';
// import { useParams } from 'react-router-dom';

const INITIAL_STATE = {
	profileUsername: '',
	profileAvatar: '',
	isFollowing: false,
	counts: { postCount: 0, followerCount: 0, followingCount: 0 }
};

const UserProfilePage = props => {
	DocTitleScrollTop('Porfile');
	const { user } = useContext(UesrContext);
	const { themeName } = useContext(MyThemeContext);
	const [tabValue, setTabValue] = useState(0);
	const [selectedTab, setSelectedTab] = useState('posts-tab');
	const { username } = useParams();
	const [fetchedUser, setFetchedUser] = useState(INITIAL_STATE);
	const [actionLoading, setActionLoading] = useState(false);
	const [followReqestCount, setFollowRequestCount] = useState(0);
	const [unFollowReqestCount, setUnFollowRequestCount] = useState(0);

	const sleep = ms => new Promise(r => setTimeout(r, ms));
	// fetch user
	useEffect(() => {
		const cancelTokenSource = Axios.CancelToken.source();
		const fetchUser = async name => {
			setFetchedUser(INITIAL_STATE);
			setSelectedTab('posts-tab');
			setTabValue(0);
			await sleep(500);
			try {
				const response = await Axios.post(
					`/profile/${name}`,
					{
						token: user && user.token
					},
					{ cancelToken: cancelTokenSource.token }
				);
				console.log(response, 'Fetched User');
				if (response.status === 200 && response.data) {
					setFetchedUser(response.data);
				} else if (response.status === 200 && !response.data) {
					await sleep(500);
					customHistory.push('/notfound');
				}
			} catch (e) {
				if (Axios.isCancel(e)) {
					console.log('Cought cancel');
				} else {
					throw e;
				}
			}
		};
		fetchUser(username);

		// cleanup
		return () => {
			cancelTokenSource.cancel();
		};
	}, [user, username]);

	//  follow effect
	useEffect(() => {
		if (followReqestCount > 0 && fetchedUser.profileUsername) {
			setActionLoading(true);
			const cancelTokenSource = Axios.CancelToken.source();
			const { profileUsername } = fetchedUser;
			const followUser = async name => {
				await sleep(400);
				try {
					const response = await Axios.post(
						`/addFollow/${name}`,
						{
							token: user && user.token
						},
						{ cancelToken: cancelTokenSource.token }
					);
					console.log('follow response', response);
					if (response.status === 200 && response.data) {
						setFetchedUser(prevState => ({
							...prevState,
							isFollowing: true,
							counts: {
								...prevState.counts,
								followerCount: prevState.counts.followerCount + 1
							}
						}));
						setActionLoading(false);
					} else if (response.status === 200 && !response.data) {
						await sleep(500);
						customHistory.push('/notfound');
					}
				} catch (e) {
					if (Axios.isCancel(e)) {
						console.log('Cought cancel');
					} else {
						throw e;
					}
				}
			};
			followUser(profileUsername);

			// cleanup
			return () => {
				cancelTokenSource.cancel();
			};
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [followReqestCount]);

	//  unfollow effect
	useEffect(() => {
		if (unFollowReqestCount > 0 && fetchedUser.profileUsername) {
			setActionLoading(true);
			const cancelTokenSource = Axios.CancelToken.source();
			const { profileUsername } = fetchedUser;
			const unFollowUser = async name => {
				await sleep(400);
				try {
					const response = await Axios.post(
						`/removeFollow/${name}`,
						{
							token: user && user.token
						},
						{ cancelToken: cancelTokenSource.token }
					);
					console.log('unFollow response', response);
					if (response.status === 200 && response.data) {
						setFetchedUser(prevState => ({
							...prevState,
							isFollowing: false,
							counts: {
								...prevState.counts,
								followerCount: prevState.counts.followerCount - 1
							}
						}));
						setActionLoading(false);
					} else if (response.status === 200 && !response.data) {
						await sleep(400);
						customHistory.push('/notfound');
					}
				} catch (e) {
					if (Axios.isCancel(e)) {
						console.log('Cought cancel');
					} else {
						throw e;
					}
				}
			};
			unFollowUser(profileUsername);

			// cleanup
			return () => {
				cancelTokenSource.cancel();
			};
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [unFollowReqestCount]);

	const handleChange = (event, newValue) => {
		setTabValue(newValue);
	};

	const handleTabClick = tabTitle => {
		setSelectedTab(tabTitle);
	};

	const startFollowing = () => {
		setFollowRequestCount(prevState => prevState + 1);
	};

	const startUnFollowing = () => {
		setUnFollowRequestCount(prevState => prevState + 1);
	};

	const AvatarNameBtn = () => {
		if (fetchedUser.profileUsername) {
			const {
				profileUsername,
				profileAvatar,
				isFollowing,
				counts: { postCount, followerCount, followingCount }
			} = fetchedUser;
			return (
				<>
					<div className="avatar_name_btn">
						<Avatar className="avatarDiv" src={profileAvatar} alt="user img" />
						<Typography variant="h5" component="p" className="userName">
							{profileUsername}
						</Typography>
						{!isFollowing && profileUsername !== user.username && (
							<ButtonWithLoading
								variant="contained"
								color="primary"
								// startIcon={<PersonAddRounded />}
								startIcon={
									actionLoading ? null : (
										<i
											style={{ fontSize: '15px' }}
											className="icon-user-add-outline"
										></i>
									)
								}
								disableElevation
								btnText="Follow"
								onClick={startFollowing}
								isSubmitting={actionLoading}
								loadingMsg="Please Wait.."
							/>
						)}

						{isFollowing && profileUsername !== user.username && (
							<ButtonWithLoading
								variant="contained"
								color="primary"
								startIcon={
									actionLoading ? null : (
										<i
											style={{ fontSize: '15px' }}
											className="icon-user-delete-outline"
										></i>
									)
								}
								disableElevation
								btnText="Un Follow"
								onClick={startUnFollowing}
								isSubmitting={actionLoading}
								loadingMsg="Please Wait.."
							/>
						)}
					</div>
					<Paper className="tabsPaper" square={true} elevation={0}>
						<Tabs
							value={tabValue}
							onChange={handleChange}
							indicatorColor="primary"
							textColor="primary"
						>
							<Tab
								label={
									<div className="tabLabel">
										Posts
										<Typography variant="h6" component="p" color="secondary">
											{postCount}
										</Typography>
									</div>
								}
								onClick={() => handleTabClick('posts-tab')}
							/>
							<Tab
								label={
									<div className="tabLabel">
										followers
										<Typography variant="h6" component="p" color="secondary">
											{followerCount}
										</Typography>
									</div>
								}
								onClick={() => handleTabClick('followers-tab')}
							/>
							<Tab
								// label={`Following ${followingCount}`}
								label={
									<div className="tabLabel">
										Following
										<Typography variant="h6" component="p" color="secondary">
											{followingCount}
										</Typography>
									</div>
								}
								onClick={() => handleTabClick('following-tab')}
							/>
						</Tabs>
					</Paper>
				</>
			);
		} else {
			return (
				<ContentLoader height="72" {...pickSkeletonColor(themeName)}>
					{/* <rect x="0" y="0" rx="5" ry="5" width="70" height="70" /> */}
					<circle cx="32" cy="32" r="32" />
					<rect x="80" y="17" rx="4" ry="4" width="300" height="13" />
					<rect x="80" y="40" rx="3" ry="3" width="250" height="10" />
				</ContentLoader>
			);
		}
	};

	return (
		<div className="myPage profilePage mfaContainer">
			<div className="profilePageContent">
				{AvatarNameBtn()}

				{selectedTab === 'posts-tab' && (
					<ProfilePosts fetchedUser={fetchedUser} />
				)}
				{selectedTab === 'followers-tab' && (
					<ProfileFollowers fetchedUser={fetchedUser} />
				)}
				{selectedTab === 'following-tab' && (
					<ProfileFollowing fetchedUser={fetchedUser} />
				)}
			</div>
		</div>
	);
};

export default UserProfilePage;
